import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Ant Design v5 официально поддерживает React 16–18. Патч закрывает
// несовместимости с React 19 и снимает предупреждение о версии.
import "@ant-design/v5-patch-for-react-19";

import App from "./App";
import "./index.css";
import dayjs from "dayjs";
import "dayjs/locale/ru";

// Даты в таблицах, графиках и календарях — по-русски, как и весь интерфейс:
// antd получает русскую локаль через ConfigProvider, а dayjs — только так.
dayjs.locale("ru");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
